import { Application, Graphics, Sprite, Container } from 'pixi.js';

export default defineNuxtPlugin(() => {
  // const PIXI = {
  //   Application,
  //   Graphics,
  //   Sprite,
  //   Container,
  //   RenderTexture,
  //   Point,
  // };
  //
  // return {
  //   provide: { PIXI },
  // };
});
